'use strict';

var React = require('react');

var SvgEmailNewsletterIcon = function SvgEmailNewsletterIcon(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    viewBox: "0 0 20 20"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M8.5 6.5a.75.75 0 0 0 0 1.5h3a.75.75 0 0 0 0-1.5h-3Z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M8 3.5a2.75 2.75 0 0 0-2.75 2.75v.5h-1.75a1 1 0 0 0-1 1v6a2.75 2.75 0 0 0 2.75 2.75h9.5a2.75 2.75 0 0 0 2.75-2.75v-6a1 1 0 0 0-1-1h-1.75v-.5a2.75 2.75 0 0 0-2.75-2.75h-4Zm2 7.849-3.25-2.167v-2.932c0-.69.56-1.25 1.25-1.25h4c.69 0 1.25.56 1.25 1.25v2.932l-3.25 2.167Zm6-2.198v4.599c0 .69-.56 1.25-1.25 1.25h-9.5c-.69 0-1.25-.56-1.25-1.25v-4.599l6 4 6-4Z"
  }));
};
SvgEmailNewsletterIcon.displayName = "EmailNewsletterIcon";

exports.SvgEmailNewsletterIcon = SvgEmailNewsletterIcon;
